import React from 'react'
import PropTypes from 'prop-types'

function PartnerBox({ partner, imgPath }) {
  return (
    <div className="partners-tier-container__partner col-12 col-md-6">
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className="card card--interactive">
            <a href={partner.url} className="link--primary-dark" target="_blank">
              <img src={imgPath} alt={partner.name} />
            </a>
          </div>
        </div>
        <div className="col-12 col-sm-6 partner-info">
          <div className="partner-info__title">
            <a href={partner.url} className="link--primary-dark" target="_blank">{partner.name}</a>
          </div>
          <p dangerouslySetInnerHTML={{ __html: partner.description }} />
        </div>
      </div>
    </div>
  )
}

PartnerBox.propTypes = {
  partner: PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  imgPath: PropTypes.string.isRequired,
}

export default PartnerBox
